import { ReactNode } from "react";

import { Attribute, Game, RankifierConfiguration } from "../gql/graphql";
import { RankifierDestinationsProvider, RenderableDestinations } from "./rankifier/rankifierDestinations";
import { RankifierGame, RankifierGameConfiguration } from "../reducers/rankifier";
import { RankifierStateProvider } from "./rankifier/rankifierState";

export type DestinationKind = "all" | RenderableDestinations;

export interface RankifierCardType {
  attribute: Attribute;
  index: number;
}

interface RankifierContextProviderProps {
  children: ReactNode;
  game: Game;
  onGameFinished: (newResponseId?: string) => void;
}

export const RankifierContextProvider = ({ game, children, onGameFinished }: RankifierContextProviderProps) => {
  const { attributes, numberOfRounds, cardsPerHand } = game.configuration as RankifierConfiguration;

  const numberOfHands = Math.ceil((attributes.length * numberOfRounds) / cardsPerHand);
  const rankifierGame: RankifierGame = {
    ...game,
    configuration: {
      ...game.configuration,
      numberOfHands,
    } as RankifierGameConfiguration,
  };

  return (
    <RankifierDestinationsProvider
      cardsInDeck={numberOfHands * cardsPerHand}
      cardsPerHand={cardsPerHand}
      cardsInSelected={numberOfHands}
    >
      <RankifierStateProvider game={rankifierGame} onGameFinished={onGameFinished}>
        {children}
      </RankifierStateProvider>
    </RankifierDestinationsProvider>
  );
};
